export enum BrowserStorageKey{
    Lanaguage = "lang"
}